
module dg.lists {

    class PaginationController implements ng.IController {
        private queryManipulator: dg.actions.ServerQueryManipulator;

        $onInit() {

        }

        goPreviousPage = () => {
            if (this.queryManipulator.pagingOptions.pageNumber != 1) {
                this.queryManipulator.pagingOptions.pageNumber -= this.queryManipulator.pagingOptions.pageStep;

                this.queryManipulator.changePage(this.queryManipulator.pagingOptions);
            }
        }

        goNextPage = () => {
            if (this.queryManipulator.hasNextPage()) {
                this.queryManipulator.pagingOptions.pageNumber += this.queryManipulator.pagingOptions.pageStep;

                this.queryManipulator.changePage(this.queryManipulator.pagingOptions);
            }
        }

    }

    angular.module('dg.lists').component('pagination', {
        bindings: {
            queryManipulator: '<'
        },
        controller: PaginationController,
        templateUrl: '/digmo/src/lists/pagination.html'
    });
}